import Loadable from '../../components/loadable';

const ManageWorkoutCategories = Loadable({
  loader: () => import('../../pages/workouts/manage_workout_categories'),
  type: 'modal',
});

angular.module('gym').value('ManageWorkoutCategories', ManageWorkoutCategories);
